import { useEffect } from 'react';

import css from './Burger.module.scss';

const Burger = ({ isMobileMenuOpen, setMobileMenuOpen }) => {
  useEffect(() => {
    return () => setMobileMenuOpen(false);
  }, []);

  return (
    <button
      type="button"
      onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
      className={css.burger}
    >
      {!isMobileMenuOpen && <span>Menu</span>}
      {isMobileMenuOpen && <span>Close</span>}
    </button>
  );
};

export default Burger;
